define('controllers/cloudacademy/mod-cloud-academyInfo.ctrl',['app', 'mainCons', 'viewer'], function (app, mainCons, imgViewer) {
    app.controller('ModCloudCademyInfoCtrl', ['$q', '$scope', '$state', '$stateParams', '$location', '$filter', 'auiUpload', 'auiDialog',
        'cloudAcademyService', 'UserInfo', 'auiAgreementHelper', '$rootScope',
        function ($q, $scope, $state, $stateParams, $location, $filter, auiUpload, auiDialog,
                  cloudAcademyService, UserInfo, auiAgreementHelper, $rootScope) {
            var Model = $scope.Model = {};
            Model = $scope.Model = {
                userInfo: {},
                lectrueInfo: {},
                trainingAgency: {},
                trainingInstructor: {
                    experienceDetails: []
                },
                positions: [],
                isAudting: false
            };
            $scope.cancel = cancel;
            //查询协议
            var agreements = [{agrType: '1003', country: 'cn', count: 1},
                {agrType: systemParaConf.cloudAcademyAgreement.servicePdfType, country: 'cn', count: 1},
                {agrType: systemParaConf.cloudAcademyAgreement.tremPdfType, country: 'cn', count: 1}
            ]
            // 查询是否签署过最新商户协议和云学院的相关协议 {agrType: agree.agreementType, country: 'cn', count: 1}
            auiAgreementHelper.checkAgreements(agreements, function () {
                $rootScope.toSettingUserInfo();
            }).then(function (data) {
                var isSigned = data.signed; //是否已经签署最新协议
                //如果已经签署跳到此页面
                if (isSigned) {
                    init();
                } else {
                    $rootScope.toSettingUserInfo();
                }
            });

            Model.instructorPicUrlWH = Model.agencyLogoUrlWH = {
                height: "150px",
                left: "0px",
                top: "0px",
                width: "150px"
            };
            Model.downLoadAgreement = function () {
                auiAgreementHelper.viewAndDownloadAgreements([systemParaConf.cloudAcademyAgreement.servicePdfType,systemParaConf.cloudAcademyAgreement.tremPdfType, 1003]);
            };

            function init() {
                UserInfo.promise().then(function (user) {
                    Model.userInfo = user;
                    cloudAcademyService.queryLecturerInfo().then(function (data) {
                        Model.lectrueInfo = data.lectrueInfo;
                        if (!Model.lectrueInfo || !AUI.BaseJSUtil.contains([1, 2, 4, 5, 6], Model.lectrueInfo.auditState)) {
                            cancel();
                        }
                        if (Model.userInfo.userType == 1) {
                            getPositions();
                        }
                        //审核中
                        if (data.lectrueInfo.auditState == 1 || data.lectrueInfo.auditState == 4) {
                            Model.isAudting = true;
                            if (Model.userInfo.userType == 2) {
                                Model.trainingAgency = angular.fromJson(data.lectrueInfo.updateInfo);
                            } else {
                                Model.trainingInstructor = angular.fromJson(data.lectrueInfo.updateInfo);
                                Model.trainingInstructor.experienceDetails = angular.fromJson(Model.trainingInstructor.experience);
                                getPositions(Model.trainingInstructor);
                            }

                        } else {
                            if (Model.userInfo.userType == 2) {
                                Model.trainingAgency = data.trainingAgency;
                            } else {
                                Model.trainingInstructor = data.trainingInstructor;
                                Model.trainingInstructor.experienceDetails = angular.fromJson(Model.trainingInstructor.experience);
                                getPositions(Model.trainingInstructor);
                            }
                        }
                    });
                });
            }

            function getPositions(trainingInstructor) {
                var defer = $q.defer();
                cloudAcademyService.getPositionList().then(function (res) {
                    Model.positions = res;
                    Model.positions.forEach(function (position) {
                        if (position.positionID == trainingInstructor.positionID) {
                            Model.trainingInstructor.position = position;
                        }
                    });
                    defer.resolve(Model);
                });
                return defer.promise;
            }


            Model.uploadInstructorPicUrl = function (files, options) {
                upload2openUP(files, options, 'instructorPicUrl', 'instructorPicUrlWH', [150, 150]);
            };

            Model.uploadAgencyLogoUrl = function (files, options) {
                upload2openUP(files, options, 'agencyLogoUrl', 'agencyLogoUrlWH', [150, 150]);
            };


            function upload2openUP(files, options, img, imgWH, array) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        var imgtemp = new Image();
                        imgtemp.src = fileUrl;
                        imgtemp.onload = function () {
                            if (imgtemp.width != array[1] || imgtemp.height != array[0]) {
                                auiDialog.fail('错误', '请上传正确尺寸的图片。');
                                return;
                            }

                            switch (img) {
                                case 'agencyLogoUrl' :
                                    Model.trainingAgency.agencyLogoUrl = fileUrl;
                                    break;
                                case 'instructorPicUrl' :
                                    Model.trainingInstructor.instructorPicUrl = fileUrl;
                                    break;
                            }
                            $scope.lectrueInfoForm.$dirty = true;
                            AUI.HTMLUtil.drawImage(150, 150, fileUrl, function (wh) {
                                $scope.$apply(function () {
                                    switch (imgWH) {
                                        case 'instructorPicUrlWH' :
                                            Model.instructorPicUrlWH = wh;
                                            break;
                                        case 'agencyLogoUrlWH' :
                                            Model.agencyLogoUrlWH = wh;
                                            break;
                                    }
                                });
                            });
                        };

                    }
                });
            }

            //取消
            function cancel() {
                $state.go('mysetting', {reload: true});
            }


            Model.doSubmit = function () {
                if (!$scope.lectrueInfoForm.$valid || !$scope.lectrueInfoForm.$dirty || Model.isAudting) {
                    return;
                }
                var defer = $q.defer();
                updateLecturer(defer);
                return defer.promise;
            };


            function updateLecturer(defer) {
                var param = generParam();
                cloudAcademyService.updateLecturer(param).then(function (data) {
                    if (data.resultCode == 0) {
                        auiDialog.success('成功', '提交成功。', function () {
                            init();
                        });
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                }).catch(function () {
                    defer.reject();
                });
            }

            function generParam() {
                var param = {
                    req: {}
                };
                if (Model.userInfo.userType == 1) {
                    var trainingInstructor = {
                        companyName: Model.trainingInstructor.companyName,
                        positionID: Model.trainingInstructor.position.positionID,
                        introduction: Model.trainingInstructor.introduction,
                        instructorPicUrl: Model.trainingInstructor.instructorPicUrl,
                        teachingField: Model.trainingInstructor.teachingField,
                        experience: JSON.stringify(Model.trainingInstructor.experienceDetails)
                    };
                    param.req.trainingInstructor = trainingInstructor;
                } else {
                    var trainingAgency = {
                        agencyName: Model.trainingAgency.agencyName,
                        agencyWebSite: Model.trainingAgency.agencyWebSite,
                        agencyIntroduction: Model.trainingAgency.agencyIntroduction,
                        agencyLogoUrl: Model.trainingAgency.agencyLogoUrl,
                        teachingField: Model.trainingAgency.teachingField
                    };
                    param.req.trainingAgency = trainingAgency;
                }
                return param;
            }

        }]);
});

